import { component as defineComponent } from 'flightjs';
import trackEvent from '@99designs/utils/platform/trackEvent';

/*global draftPrefillData */

function DraftPrefillToggle() {
    this.toggle = function(e) {
        if (e.target.value == 'no') {
            this.resetFields();

            trackEvent('Cleared Launch Prefilled Brief');
        } else {
            this.prefillFields();
        }
    };

    this.prefillFields = function() {
        for (var fieldKey in draftPrefillData) {
            var $field = this.findField(fieldKey);
            $field.val(draftPrefillData[fieldKey]);
        }
    };

    this.resetFields = function() {
        for (var fieldKey in draftPrefillData) {
            var $field = this.findField(fieldKey);
            $field.val('');
        }
    };

    this.convertFieldKey = function(s) {
        return s.replace(/(\_\w)/g, function(m) {
            return m[1].toUpperCase();
        });
    };

    this.findField = function(fieldKey) {
        return $('#briefform_' + this.convertFieldKey(fieldKey));
    };

    this.after('initialize', function() {
        this.on('change', this.toggle);
    });
}

export default defineComponent(DraftPrefillToggle);



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/draft-prefill-toggle.js